<div *ngIf="pages?.length > 1" class="show-more-container">
    <div *ngIf="showPageOptions" class="paginations">
        <div class="page-options">
            <div class="page-option" title="{{i + 1}}. {{ page.title }}"
                 [ngClass]="{ active: currentPageIndex == i }"
                 [attr.id]="i+1"
                 *ngFor="let page of pages; let i = index" (click)="goToPage(i)">
                <a>{{i + 1}}. {{ page.title }}</a>
            </div>
        </div>
    </div>

    <div class="wrappers">
        <div class="links flex flex-row justify-start items-center">
            <a title="Previous Page" [ngClass]="{ disable: currentPageIndex === 0 }"
               class="show-more"
               (click)="goToPreviousPage()">
                <i class="fa-solid fa-arrow-left"></i>
            </a>
            <div (click)="onTogglePagination()" class="page-info flex flex-row justify-center items-center">
                <div>
                    <span class="page-indicator">Page {{currentPageIndex + 1}} of {{pages.length}}</span>
                    <i *ngIf="!showPageOptions" class="fa-regular fa-chevron-up"></i>
                    <i *ngIf="showPageOptions" class="fa-regular fa-chevron-down"></i>
                </div>
            </div>
            <a title="Next Page" [ngClass]="{ disable: currentPageIndex === pages.length - 1 }"
               class="show-more"
               (click)="goToNextPage()">
                <i class="fa-solid fa-arrow-right"></i>
            </a>
        </div>
    </div>
</div>

<div class="elite-form-container">
    <div class="wrapper">
        <app-elite-form-pages-container
            *ngIf="pages.length > 0 && currentPageIndex >= 0"
            class="full-grow-no-shrink-no-basis"
            [pageModel]="pages[currentPageIndex]"
            [totalPage]="pages.length"
            [questions]="questions"
            [flowchartSection]="getFlowchartSection(pages[currentPageIndex]?.flowchartSectionId)"
        ></app-elite-form-pages-container>
    </div>
</div>